<script setup>
defineProps({
  article: {
    type: Object,
    required: true,
  },
  isArticleCardsType: {
    type: Boolean,
  },
  opinionAuthorId: {
    type: String,
    default: undefined,
  },
});
</script>

<template>
  <div class="crew-block">
    <div class="crew-block__wrap">
      <ArticleCrew
        :crew="article.crew"
        class="crew-block__item"
        is-authors
        :general-author-id="opinionAuthorId"
        :is-light="isArticleCardsType"
      />
      <ArticleCrew
        :crew="article.crew"
        class="crew-block__item crew-block__item--desktop"
        :is-light="isArticleCardsType"
      >
        <template #lastElement>
          <ArticlePublishedDate
            :date="article.publishedAt"
            :is-light="isArticleCardsType"
          />
        </template>
      </ArticleCrew>
    </div>
    <div class="crew-block__wrap crew-block__wrap--mobile">
      <ArticleCrew :crew="article.crew" :is-light="isArticleCardsType">
        <template #lastElement>
          <ArticlePublishedDate
            :date="article.publishedAt"
            :is-light="isArticleCardsType"
          />
        </template>
      </ArticleCrew>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.crew-block {
  &__wrap {
    display: flex;
    flex-direction: column;

    &--mobile {
      display: none;
    }
  }

  &__item:not(:last-child) {
    margin-bottom: 16px;
  }

  @media (--small-vp) {
    &__wrap {
      order: 1;
    }

    &__wrap--mobile {
      display: block;
      order: 3;
    }

    &__item {
      &--desktop {
        display: none;
      }
    }

    &__crew:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
